import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import blogService from '../../service/blogService';
import './blog.css';

export default function ViewBlog() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);

    const findHourDifference = (dbDate) => {
        const date = new Date(dbDate);
        const currentDate = new Date();
        const timeDiff = currentDate - date;
        return Math.floor(timeDiff / (1000 * 60 * 60));
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await blogService.viewBlog(`${id}`);
                setBlog(response?.data?.[0] || null);
            } catch (error) {
                console.error(error);
            }
        };
        fetchData(id);
    }, [id]);

    if (!blog) {
        return <div className="blog-view">Loading...</div>;
    }

    const hourDiff = findHourDifference(blog.createdAt);
    const relativeDate = hourDiff > 24 ? `${parseInt(hourDiff / 24, 10)} days ago` : `${hourDiff} hours ago`;

    return (
        <article className="blog-view">
            <img
                className="blog-view-image"
                src={`data:image/jpeg;base64,${blog.images}`}
                alt={blog.title || 'Blog cover'}
            />
            <h1>{blog.title}</h1>
            <div className="blog-view-content" dangerouslySetInnerHTML={{ __html: blog.content }}></div>
            <p className="blog-view-meta">Author: {blog.author}</p>
            <p className="blog-view-meta">Date: {relativeDate}</p>
        </article>
    );
}
